import { render, staticRenderFns } from "./aiReport.vue?vue&type=template&id=fd5d2c24&scoped=true"
import script from "./aiReport.vue?vue&type=script&lang=js"
export * from "./aiReport.vue?vue&type=script&lang=js"
import style0 from "./aiReport.vue?vue&type=style&index=0&id=fd5d2c24&prod&lang=scss&scoped=true"
import style1 from "./aiReport.vue?vue&type=style&index=1&id=fd5d2c24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5d2c24",
  null
  
)

export default component.exports